export default __webpack_public_path__ + "static/media/jaslok_vendors.caf86834.xlsx";